import React from 'react';

const BlogHero = () => {
  return (
    <div style={{ position: 'relative', height: '520px', overflow: 'hidden', marginTop: '72px' }}>
      {/* Background image */}
      <img
        src="https://img.rocket.new/generatedImages/rocket_gen_img_1adc773c2-1772193100184.png"
        alt="Dramatisk norsk fjellvei med snødekte topper og blå himmel, typisk norsk naturlandskap"
        style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 40%', filter: 'brightness(0.45) contrast(1.1)' }} />
      
      {/* Overlay gradient */}
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(5,10,18,0.85) 0%, rgba(5,10,18,0.3) 60%, transparent 100%)' }} />
      {/* Diagonal cut */}
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '80px', background: '#050A12', clipPath: 'polygon(0 100%, 100% 0, 100% 100%)' }} />

      {/* Content */}
      <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 6%', maxWidth: '900px' }}>
        {/* Label */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
          <div style={{ width: '40px', height: '3px', background: '#3B6FD4' }} />
          <span style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#3B6FD4', letterSpacing: '0.2em', textTransform: 'uppercase' }}>Blogg & Nyheter</span>
        </div>

        {/* Main title */}
        <div style={{ position: 'relative' }}>
          <h1
            style={{
              fontFamily: 'Impact, Haettenschweiler, sans-serif',
              fontSize: 'clamp(3rem, 8vw, 6rem)',
              fontWeight: 900,
              color: '#EEF0F2',
              lineHeight: 0.9,
              letterSpacing: '-0.02em',
              margin: 0,
              textTransform: 'uppercase'
            }}>
            
            NORGES
          </h1>
          <h1
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: 'clamp(2rem, 5vw, 4rem)',
              fontWeight: 400,
              fontStyle: 'italic',
              color: '#A8C4F0',
              lineHeight: 1.1,
              margin: '8px 0',
              transform: 'rotate(-1deg)',
              display: 'inline-block'
            }}>
            
            veier & historier
          </h1>
          <h1
            style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 'clamp(2.5rem, 6vw, 5rem)',
              fontWeight: 800,
              color: '#EEF0F2',
              lineHeight: 0.95,
              letterSpacing: '-0.04em',
              margin: 0,
              textTransform: 'uppercase'
            }}>
            
            REDAKSJON
          </h1>
        </div>

        <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '1rem', color: 'rgba(238,240,242,0.7)', marginTop: '20px', maxWidth: '500px', lineHeight: 1.6 }}>
          Nyheter, tips og innsikt om norske veier, trafikk og kjøretøy — fra eksperter som kjenner veiene.
        </p>
      </div>

      {/* Decorative rotated label */}
      <div
        style={{
          position: 'absolute',
          top: '40px',
          right: '6%',
          transform: 'rotate(3deg)',
          background: '#3B6FD4',
          padding: '8px 16px',
          fontFamily: 'Syne, sans-serif',
          fontSize: '0.75rem',
          fontWeight: 700,
          color: '#EEF0F2',
          letterSpacing: '0.1em',
          textTransform: 'uppercase'
        }}>
        
        2026 — Vol. 4
      </div>
    </div>);

};

export default BlogHero;